// src/Dashboard/pages/user/PrepaPhysique/components/PrepaPhysiqueImageModal.jsx

import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";

import { toAbsolute } from "../utils/prepaPhysiqueUserUtils";

export default function PrepaPhysiqueImageModal({ image, onClose }) {
  useEffect(() => {
    if (!image) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [image, onClose]);

  if (!image) return null;

  return (
    <div className="fixed inset-0 z-[120]">
      <div
        className="absolute inset-0 bg-slate-950/75 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />

      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="relative w-full max-w-4xl overflow-hidden rounded-[28px] border border-white/20 bg-slate-950 shadow-2xl">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-3 top-3 z-10 inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/90 text-slate-900 shadow-sm transition hover:bg-white"
            aria-label="Fermer"
          >
            <FaTimes />
          </button>

          <div className="bg-black p-2">
            <img
              src={toAbsolute(image.src) || "/img/no-image.jpg"}
              alt={image.title || "Illustration"}
              className="max-h-[80vh] w-full rounded-[22px] object-contain"
              onError={(event) => {
                event.currentTarget.src = "/img/no-image.jpg";
              }}
            />
          </div>

          {image.title && (
            <div className="border-t border-white/10 bg-slate-950 px-5 py-3 text-sm font-bold text-white">
              {image.title}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}